const $ = jQuery.noConflict()

class StickyHeader {
    constructor() {
        this.header = '.main-header'
        this.headerStickyClass = 'main-header--transparent'
        this.inpageNav = '.sidebar-header';
    }

    init() {
        this.scroll()
        this.resize()
    }

    scroll() {
        if ($(this.header).hasClass('main-header--home')) {
            const scrollPosition = document.documentElement.scrollTop
            const headerHaveStickyClass = $(this.header).hasClass(this.headerStickyClass)
            const megaMenuIsOpen = $(this.header).find('.mega-menu-wrapper.active').length

            if (scrollPosition > 0 && headerHaveStickyClass) {
                $(this.header).removeClass(this.headerStickyClass)
            } else if (scrollPosition === 0 && !headerHaveStickyClass && megaMenuIsOpen === 0) {
                $(this.header).addClass(this.headerStickyClass)
            }
        }
    }

    resize() {
        if (!$(this.header).hasClass('main-header--home') || window.matchMedia('(max-width: 1199px)').matches) {
            $('#page').css({ 'padding-top': $(this.header).outerHeight() })
        } else {
            $('#page').css({ 'padding-top': 0 })
        }

        let adminBarHeight = $('#wpadminbar').length ? $('#wpadminbar').outerHeight() : 0

        if ($(this.inpageNav).length > 0) {
            $(this.inpageNav).css({ 'top': $(this.header).outerHeight() + adminBarHeight })
        }
    }
}

export default new StickyHeader()
